((Redactor) => {
  Redactor.add("plugin", "dealcard", {
    modals: {
      dealcard: `<form action="" id="dealCardForm" name="dealCardForm">
              <div class="form-item">
                  <label>## permalinkLabel ##</label>
                  <input required type="text" name="deal_permalink" id="deal_permalink" placeholder="## permalinkPlaceholder ##">
                  <span class="input-error"></span>
              </div>
              <div id="deal-preview" class="deal-preview hidden" style="margin-top: 15px; padding: 10px; border: 1px solid #ddd; border-radius: 4px;">
                <div class="deal-preview-loading">## loading ##</div>
              </div>
          </form>`,
    },

    translations: {
      en: {
        dealcard: I18n.t("redactor_deal_card"),
        "dealcard-label": I18n.t("redactor_deal_card_label"),
        permalinkLabel: "Deal Permalink",
        permalinkPlaceholder: "Enter deal permalink or URL",
        loading: "Loading...",
        dealNotFound: "Deal not found",
        invalidPermalink: "Please enter a valid permalink",
      },
      ru: {
        dealcard: I18n.t("redactor_deal_card"),
        "dealcard-label": I18n.t("redactor_deal_card_label"),
        permalinkLabel: "Постоянная ссылка на сделку",
        permalinkPlaceholder: "Введите постоянную ссылку или URL",
        loading: "Загрузка...",
        dealNotFound: "Сделка не найдена",
        invalidPermalink: "Пожалуйста, введите действительную постоянную ссылку",
      },
    },

    init(app) {
      this.app = app;
      this.lang = app.lang;
      this.toolbar = app.toolbar;
      this.insertion = app.insertion;
      this.marker = app.marker;
      this.selection = app.selection;
    },

    onmodal: {
      dealcard: {
        opened: (modal, form) => {
          const permalinkInput = form.getField("deal_permalink");
          permalinkInput.focus();
          
          // Add debounced preview on input
          let debounceTimer;
          permalinkInput.on('input', (e) => {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
              this._previewDeal(e.target.value);
            }, 500);
          });
        },
        insert(modal, form) {
          const dealCardForm = document.forms["dealCardForm"];
          const permalinkInput = dealCardForm.querySelector("#deal_permalink");
          const errorSpan = dealCardForm.querySelector(".input-error");
          
          if (!permalinkInput.value.trim()) {
            errorSpan.innerText = this.lang.get("invalidPermalink");
            return;
          }

          errorSpan.innerText = "";
          this._fetchAndInsertDeal(permalinkInput.value.trim());
        },
      },
    },

    start() {
      const buttonData = {
        title: this.lang.get("dealcard"),
        api: "plugin.dealcard.open",
      };
      this.toolbar.addButton("dealcard", buttonData);
    },

    open() {
      // Save the current cursor position before opening modal
      this.selection.save();
      
      const options = {
        title: this.lang.get("dealcard-label"),
        width: "600px",
        name: "dealcard",
        handle: "insert",
        commands: {
          insert: { title: this.lang.get("insert") },
          cancel: { title: this.lang.get("cancel") },
        },
      };
      this.app.api("module.modal.build", options);
    },

    _extractPermalink(input) {
      // Extract permalink from full URL or just use the input if it's already a permalink
      // Supports: /deals/, /deal/, /coupons/, /coupon/, /discussions/, /discussion/, /news/
      const urlPattern = /(?:https?:\/\/)?(?:www\.)?[^\/]+\/(?:deals?|coupons?|discussions?|news)\/([^\/\?#]+)/i;
      const match = input.match(urlPattern);
      return match ? match[1] : input;
    },

    async _previewDeal(input) {
      const previewDiv = document.getElementById("deal-preview");
      if (!input.trim()) {
        previewDiv.classList.add("hidden");
        return;
      }

      previewDiv.classList.remove("hidden");
      previewDiv.innerHTML = '<div class="deal-preview-loading">Loading...</div>';

      const permalink = this._extractPermalink(input);
      
      try {
        // Check if deal exists
        const response = await fetch(`/fetch_deal_card/${encodeURIComponent(permalink)}`, {
          method: "GET",
          headers: {
            "Accept": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          credentials: "same-origin",
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.error || "Deal not found");
        }

        if (data.success) {
          // Show iframe preview with responsive height and pass theme
          const isDarkMode = document.documentElement.classList.contains("dark");
          const embedUrl = `/embed/deal_card/${encodeURIComponent(permalink)}?theme=${isDarkMode ? 'dark' : 'light'}`;
          const isMobile = window.innerWidth < 768;
          const minHeight = isMobile ? '380px' : '280px';
          previewDiv.innerHTML = `<iframe src="${embedUrl}" class="deal-card-iframe" style="width: 100% !important; max-width: 100% !important; min-height: ${minHeight}; border: none; display: block !important;" scrolling="no" frameborder="0"></iframe>`;
          // Setup iframe resize listener for preview too
          this._setupIframeResize();
        } else {
          throw new Error(data.error || "Failed to load deal");
        }
      } catch (error) {
        previewDiv.innerHTML = `<div style="color: red;">${this.lang.get("dealNotFound")}</div>`;
      }
    },

    async _fetchAndInsertDeal(input) {
      const permalink = this._extractPermalink(input);
      const errorSpan = document.querySelector("#dealCardForm .input-error");

      try {
        const response = await fetch(`/fetch_deal_card/${encodeURIComponent(permalink)}`, {
          method: "GET",
          headers: {
            "Accept": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          credentials: "same-origin",
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.error || "Deal not found");
        }

        if (data.success) {
          this._insertDealCard(permalink);
          this.app.api("module.modal.close");
        } else {
          throw new Error(data.error || "Failed to load deal");
        }
      } catch (error) {
        errorSpan.innerText = this.lang.get("dealNotFound");
        errorSpan.style.color = "red";
      }
    },

    _insertDealCard(permalink) {
      // Pass current theme to iframe
      const isDarkMode = document.documentElement.classList.contains("dark");
      const embedUrl = `/embed/deal_card/${encodeURIComponent(permalink)}?theme=${isDarkMode ? 'dark' : 'light'}`;
      
      // Save the current scroll position
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      const wrapper = document.createElement("div");
      wrapper.className = "deal-card-wrapper";
      wrapper.setAttribute("contenteditable", "false");
      wrapper.setAttribute("data-deal-permalink", permalink);
      wrapper.style.cssText = "width: 100% !important; max-width: 100% !important;";
      
      const iframe = document.createElement("iframe");
      iframe.src = embedUrl;
      const isMobile = window.innerWidth < 768;
      const minHeight = isMobile ? '380px' : '280px';
      iframe.style.cssText = `width: 100% !important; max-width: 100% !important; min-height: ${minHeight}; border: none; display: block !important;`;
      iframe.setAttribute("scrolling", "no");
      iframe.setAttribute("frameborder", "0");
      iframe.className = "deal-card-iframe";
      
      wrapper.appendChild(iframe);

      // Restore the saved cursor position
      this.selection.restore();
      
      // Insert at the current cursor position
      this.insertion.insertHtml(wrapper.outerHTML);
      
      // Setup iframe resize listener
      this._setupIframeResize();
      
      // Restore scroll position to prevent jumping
      setTimeout(() => {
        window.scrollTo(0, scrollTop);
      }, 0);
    },

    _setupIframeResize() {
      if (window._dealCardResizeListenerSetup) return;
      window._dealCardResizeListenerSetup = true;

      window.addEventListener('message', function(event) {
        if (event.data.type === 'resize-iframe') {
          // Find all deal card iframes and resize them
          const iframes = document.querySelectorAll('.deal-card-iframe');
          iframes.forEach(iframe => {
            if (iframe.contentWindow === event.source) {
              // Add extra padding for safety on mobile
              const isMobile = window.innerWidth < 768;
              const extraPadding = isMobile ? 20 : 10;
              const newHeight = (event.data.height + extraPadding) + 'px';
              iframe.style.height = newHeight;
              iframe.style.minHeight = newHeight;
              iframe.style.maxHeight = 'none';
            }
          });
        }
      });
    },
  });
})(Redactor);
